import { useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell,
  PieChart, Pie,
} from "recharts";

function Metric({ label, value, suffix = "" }) {
  return (
    <div className="border border-border bg-white p-5">
      <div className="label-caps text-muted-foreground">{label}</div>
      <div className="font-heading text-3xl font-black mt-2">{value}{suffix}</div>
    </div>
  );
}

export default function Reports() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/reports").then((res) => setR(res.data)); }, []);
  if (!r) return <div className="p-8 text-muted-foreground">Loading reports…</div>;

  const openClosed = [
    { name: "Open", value: r.open_count },
    { name: "Closed/Resolved", value: r.closed_count },
  ];
  const COLORS = ["#002FA7", "#10b981"];

  return (
    <div className="p-5 sm:p-8 fade-up">
      <div className="mb-6">
        <div className="label-caps text-muted-foreground">Insights</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tighter">Reports</h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-border border border-border mb-6">
        <Metric label="Avg resolution" value={r.avg_resolution_hours} suffix="h" />
        <Metric label="Assign SLA met" value={r.sla_assign_compliance} suffix="%" />
        <Metric label="Attend SLA met" value={r.sla_attend_compliance} suffix="%" />
        <Metric label="Recurring rate" value={r.recurring_rate} suffix="%" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className="lg:col-span-2 border border-border bg-white p-5">
          <div className="label-caps text-muted-foreground mb-4">Complaints per engineer</div>
          {r.per_engineer.length === 0 ? <div className="text-sm text-muted-foreground">No data.</div> : (
            <ResponsiveContainer width="100%" height={280}>
              <BarChart data={r.per_engineer}>
                <XAxis dataKey="engineer" tick={{ fontSize: 12 }} />
                <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
                <Tooltip />
                <Bar dataKey="total" fill="#002FA7" name="Total" />
                <Bar dataKey="resolved" fill="#10b981" name="Resolved" />
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>

        <div className="border border-border bg-white p-5">
          <div className="label-caps text-muted-foreground mb-4">Open vs Closed</div>
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie data={openClosed} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={90} label>
                {openClosed.map((e, i) => <Cell key={i} fill={COLORS[i]} />)}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="mt-6 border border-border bg-white p-5 max-w-md">
        <div className="label-caps text-muted-foreground mb-2">Repeat / Recurring</div>
        <div className="flex justify-between text-sm py-1"><span>Repeat rate</span><span className="font-mono font-bold">{r.repeat_rate}%</span></div>
        <div className="flex justify-between text-sm py-1"><span>Recurring rate</span><span className="font-mono font-bold text-signal">{r.recurring_rate}%</span></div>
        <div className="flex justify-between text-sm py-1 border-t border-border mt-1 pt-1"><span>Total complaints</span><span className="font-mono font-bold">{r.total}</span></div>
      </div>
    </div>
  );
}
